import type { Content, State } from '../../typings'

export const changeContentProducer = (
  state: State,
  payload: Content,
): State => ({ ...state, content: payload })
